import React, { useState, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";

import lightLogo from "../../../img/logo-light.png";
import { performResetEmail } from "../../../networking/authentication/networking";

import {
  sendSuccessNotification,
  sendErrorNotification,
} from "../../../components/universal/notifications/notifications";
import { ToastContainer } from "react-toastify";
import { auth } from "../../../networking/firebase";

import "react-toastify/dist/ReactToastify.css";
import "./style.scss";
import { Label } from "../../library/label";
import { Input } from "../../library/input";

const Index = (props) => {
  const user = auth.currentUser && auth.currentUser.uid;
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false);

  const [loading, setLoading] = useState(false);

  const clickResetPassword = async () => {
    try {
      if (email) {
        setLoading(true);
        const details = { email: email };
        const reset = await performResetEmail(details);
        if (reset.error === null) {
          setEmail("");
          setLoading(false);
          setSuccess(true);
          sendSuccessNotification("Lenke for tilbakestilling ble sendt.");
        }
      } else {
        setLoading(false);
        sendErrorNotification("Vennligst fyll inn en e-post.");
      }
    } catch (e) {
      setLoading(false);
      sendErrorNotification(e.error);
    }
  };

  useEffect(() => {
    if (user) {
      props.history.push("/dashboard/oversikt");
    }
  }, user);

  return (
    <section className="forgot-password-page-section">
      <div className="inner-forgot-password-page-container">
        <div className="full-content-container">
          <div className="forgot-password-display-container">
            <div className="forgot-password-box-container">
              <div className="inner-forgot-password-box-container">
                <Link to="/">
                  <img
                    alt="Leadfind logo"
                    className="forgot-password-logo"
                    src={lightLogo}
                  />
                </Link>
                <h3 className="forgot-password-title">Tilbakestill passord</h3>
                <div className="forgot-password-display-container">
                  {success && !loading ? (
                    <div className="success-container">
                      <h3 className="success-title">
                        Du vil snart motta en e-post med tilbakestillingslenke
                        dersom e-posten du oppga var gyldig.
                      </h3>
                    </div>
                  ) : (
                    <div className="input-group">
                      <Label version={1} weight="bold">
                        E-post
                      </Label>
                      <Input
                        type="email"
                        placeholder="gavin.belson@hooli.xyz"
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                      />
                    </div>
                  )}
                  <div className="button-container">
                    {success ? (
                      <Link to="/logg-inn">
                        <button className="login-button">
                          Gå tilbake til innlogging
                        </button>
                      </Link>
                    ) : (
                      <button
                        onClick={clickResetPassword}
                        className="login-button"
                      >
                        {loading ? (
                          <i className="fas fa-circle-notch fa-spin"></i>
                        ) : null}{" "}
                        {loading ? "Sender e-post.." : "Send meg nytt passord"}
                      </button>
                    )}
                  </div>
                  <div className="sign-up-container">
                    <p className="signup-label">
                      Ønsker du å logge inn?{" "}
                      <Link to="/logg-inn">Klikk her</Link>.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};

export default withRouter(Index);
